// Generated by CoffeeScript 2.4.1
(function() {
  var WeaverModelContext, semver;

  semver = require('semver');

  WeaverModelContext = class WeaverModelContext {
    constructor(definition, model) {
      this.definition = definition;
      this.model = model || this;
      this._graph = `${this.definition.name}-${semver.major(this.definition.version)}`;
    }

    getGraph() {
      return this._graph;
    }

    includeKeyToModelTab(key) {
      var object, ref;
      object = (ref = this.definition.includes) != null ? ref[key] : void 0;
      if (object != null) {
        return `${object.name}@${object.version}`;
      } else {
        return null;
      }
    }

    isNativeClass(className) {
      return className.indexOf('.') === -1 || className.startsWith('http');
    }

    // eg (test-doc-model:)td.Document is processed to test-doc-model:Document
    getNodeNameByKey(dotPath) {
      var context, first, rest, tag;
      if (dotPath.startsWith('http')) {
        return dotPath;
      }
      [first, ...rest] = dotPath.split('.');
      if (rest.length === 0 && dotPath.indexOf(':') < 0) {
        return `${this.definition.name}:${dotPath}`;
      }
      if (rest.length === 0 && dotPath.indexOf(':') >= 0) {
        return `${dotPath}`;
      }
      if (first.indexOf(':') < 0) {
        tag = this.includeKeyToModelTab(first);
        if (tag != null) {
          context = this.model.contextMap[tag];
          return context.getNodeNameByKey(rest.join('.'));
        }
      } else {
        throw new Error("This route is deprecated");
      }
      return null;
    }

  };

  module.exports = WeaverModelContext;

}).call(this);
